var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLikeFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 302,
    height: 302,
    viewBox: "0 0 302 302",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2139_46)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M220.209 11.5391C206.039 11.7595 192.179 15.7149 180.027 23.0059C167.875 30.2969 157.863 40.6653 151 53.0641C144.138 40.6653 134.125 30.2969 121.974 23.0059C109.822 15.7149 95.9615 11.7595 81.792 11.5391C59.2042 12.5204 37.9228 22.4017 22.5973 39.024C7.27177 55.6463 -0.852157 77.6585 0.000370339 100.252C0.000370339 185.504 137.863 283.968 143.727 288.146L151 293.292L158.274 288.146C164.137 283.993 302 185.504 302 100.252C302.853 77.6585 294.729 55.6463 279.403 39.024C264.078 22.4017 242.797 12.5204 220.209 11.5391Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2139_46"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 302,
    height: 302,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeFilled);
export default __webpack_public_path__ + "static/media/like-filled.dcbbf41ca151f3d8fcea1c361e944e80.svg";
export { ForwardRef as ReactComponent };